import ptBR from '@/lang/language/pt-br';

export default {
	'pt-BR': ptBR,
};
